import React from 'react'
import { Link } from 'react-router-dom'
import BoatsAdd from './BoatsAdd'
import Constant from '../../Constant'
class BoatsAddTab extends React.Component {
  state = {
    language_data: [],
  }

  componentDidMount() {
    if (
      this.props.match.params.boatId !== undefined &&
      this.props.match.params.boatId !== null &&
      this.props.match.params.boatId !== 0 &&
      this.props.match.params.boatId !== ''
    ) {
      this.setState({ boatId: this.props.match.params.boatId })
    }

    this.getLanguageList()
  }

  getLanguageList = () => {
    var language_data = Constant.getLanguageList()
    this.setState({
      language_data: language_data,
      language_id: language_data[0].id,
      isLoading: false,
    })
  }

  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>
                      {this.props.match.params.boatId ? 'Edit' : 'Add'} {this.props?.match?.params?.boatType}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <span onClick={() => window.history.back()}>{this.props.match.params.boatType}</span>
                    </li>
                    <li className="breadcrumb-item active">
                      {this.props.match.params.boatId ? 'Edit' : 'Add'} {this.props.match.params.boatType}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    {/* <ul className="nav nav-tabs  tabs" role="tablist">
                      {this.state.language_data !== undefined &&
                      this.state.language_data !== []
                        ? this.state.language_data.map((language) => (
                            <li
                              className="nav-item"
                              key={language.id}
                              onClick={this.handleLanguage.bind(
                                this,
                                language.id
                              )}
                            >
                              <a
                                className={
                                  this.state.language_id === language.id
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                id={"language_" + language.id}
                                data-toggle="tab"
                                href={"#Products_add_" + language.id}
                                role="tab"
                                aria-controls={"Products_add_" + language.id}
                                aria-selected="true"
                              >
                                {language.name}{" "}
                              </a>
                            </li>
                          ))
                        : ""}
                    </ul> */}
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'Products_add_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        <BoatsAdd
                          goBack={this.props.history.goBack}
                          boatType={this.props.match.params.boatType}
                          boatId={this.state.boatId}
                          language_id={this.state.language_id}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BoatsAddTab
